module.exports = __webpack_public_path__ + "image/demo_1_4_e161d.png";